<app-modal-base [title]="dialogTitle" (onSubmitEvent)="onSubmit()" [loading]="isLoading" [isDisabled]="form.invalid">
  <ng-container main *ngTemplateOutlet="content"></ng-container>
</app-modal-base>

<ng-template #content>
  <div mat-dialog-content>
    <p>Les DPE suivants ont été trouvés à l'adresse indiquée.</p>
    <p>Choisissez celui qui correspond au bien :</p>
    <div class="formContainer d-flex justify-content-center">
      <form [formGroup]="form">

        <div class="form-group row">
          <mat-radio-group formControlName="dpeNumber" color="primary" required>
            @for (dpe of data.dpeList; track $index) {
            <mat-radio-button value="{{ dpe.number }}">
              <p>Numéro <strong>{{ dpe.number }}</strong> du {{dpe.date |
                dateFormat}}</p>
              <p>Surface {{ dpe.surface | decimalFormat }}m², Classe "{{dpe.energyClassification}}", Classe GES
                "{{dpe.gasClassification}}"{{ dpe.indications ? ' ('+dpe.indications+')' : ''}}</p>
            </mat-radio-button>
            <mat-divider></mat-divider>
            }
            <mat-radio-button value="NONE">Aucun ne correspond, je rentrerai les informations
              manuellement</mat-radio-button>
          </mat-radio-group>
        </div>

      </form>
    </div>
  </div>
</ng-template>